module.exports = "<p>\n    Ti abbiamo inviato una mail con <span>un link</span> dal quale puoi <span>riprendere la compilazione</span> da dove l'hai lasciata.\n</p>\n<br>\n<p>\n    Puoi cliccarlo in <span>qualsiasi momento</span>  per ritrovare tutti i tuoi dati: controlla la tua casella di posta!\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component.html
// module id = ./src/app/components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component.html
// module chunks = main